<template>
  <el-form ref="form" :model="form.data" :rules="form.rules" label-width="150px">
    <el-form-item :label="$vi18n('$i18n# 邮箱 #i18n$')" prop="email">
      <el-input v-model="form.data.email" disabled></el-input>
    </el-form-item>
    <el-form-item :label="$vi18n('$i18n# 验证码 #i18n$')" prop="code">
      <el-input v-model="form.data.code">
        <el-button slot="append" :disabled="!!countdown" :loading="sendCodeLoading" @click="sendCode">
          {{ countdown === 0 ? $vi18n('$i18n# 获取验证码 #i18n$') : countdown + 's' }}
        </el-button>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="loginEmailCode" :loading="loginLoading">
        {{ $vi18n('$i18n# 确定 #i18n$') }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {
  getEmailCode,
  loginEmailCode,
} from '@/api/common';
export default {
  name: 'EmailLogin',
  props: ['data'],
  data() {
    return {
      form: {
        data: {
          email: this.data.email,
          code: ''
        },
        rules: {
          email: [{ required: true, message: this.$vi18n('$i18n# 请输入邮箱 #i18n$') },],
          code: [{ required: true, message: this.$vi18n('$i18n# 请输入验证码 #i18n$') },]
        }
      },
      countdown: 0,
      sendCodeLoading: false,
      countdownTimer: null,
      loginLoading: false
    }
  },
  methods: {
    onSubmit() {
      console.log('onSubmit')
    },
    startCountDown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }
      this.countdown = 60
      this.countdownTimer = setInterval(() => {
        if (this.countdown === 0) {
          clearInterval(this.countdownTimer)
        } else {
          this.countdown--
        }
      }, 1000)
    },
    async sendCode() {
      try {
        const params = {
          email_token: this.data.email_login_token,
          uin: this.getServeUin(this.data.uin),
          ct: Math.floor(new Date().getTime() / 1000)
        }
        this.sendCodeLoading = true
        const res = await getEmailCode(params)
        this.sendCodeLoading = false
        this.startCountDown()
        console.log(res, 'getEmailCode')
        this.$message({
          message: this.$vi18n('$i18n# 验证码已发送至您的邮箱! #i18n$'),
          type: 'success',
        });
      } catch (error) {
        console.error(error)
        this.sendCodeLoading = false
      }
    },
    getServeUin (uin) {
      uin = String(uin);
      const len = uin.length;
      if (len >= 10) {
        return uin;
      } else {
        let diff = 10 - len - 1;
        let pre = '1';
        while (diff --) {
          pre += '0';
        }
        return pre + uin;
      }
    },
    async loginEmailCode() {
      await this.$refs.form.validate()
      try {
        const params = {
          email_token: this.data.email_login_token,
          email_code: this.form.data.code,
          uin: this.getServeUin(this.data.uin),
          ct: Math.floor(new Date().getTime() / 1000)
        }
        this.loginLoading = true
        const res = await loginEmailCode(params)
        this.loginLoading = false
        console.log(res, 'loginEmailCode')
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$emit('loginSuccess', res.data)
      } catch (error) {
        console.error(error)
        this.loginLoading = false
      }
    }
  }
}
</script>

<style>

</style>